<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<main class="content-page bg-gray">
    @if (security.permitted('reports', 'user audit log', 'view')) {
    <div class="content p-1">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">User Audit Report</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="col-md-12 p-1">
            <div class="rounded">
                <div class="list-bar">
                    <form [formGroup]="form" class="form-row">
                        <div class="form-group col">
                            <date-span [verb]="'Occurred'" [default]="FILTER_SPAN_KEY" [min]="'today'" [max]="'quarter'" (chosen)="spanned($event)"></date-span>
                        </div>
                        <div class="form-group col">
                            <select class="form-control" name="user" id="user-filter" formControlName="user">
                                <option value="0">All {{words[language]['users']}}</option>
                                @for (user of users; track user.id) {
                                    <option value="{{user.id}}">{{user.name}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col">
                            <select class="form-control" name="module" id="module-filter" formControlName="module">
                                <option value="">All Modules</option>
                                <option value="auth">Authentication</option>
                                <option value="collections">Collections</option>
                                <option value="contact">Contacts</option>
                                <option value="gps">GPS</option>
                                <option value="inventory">Inventory</option>
                                <option value="sales">Sales</option>
                                <option value="service">Service</option>
                                <option value="setup">Setup</option>
                                <option value="system">System</option>
                            </select>
                        </div>
                    </form>
                </div>
                <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                    @if (entries) {
                    <table class="table table-sm table-hover table-striped table-responsive-sm" id="activityTable">
                        <thead>
                            <tr>
                                <th (click)="sort('saleDate')" class="sorted" scope="col">
                                    Occurred
                                    @if (sortedAsc('createdAt')) {
                                    <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                    }
                                    @if (sortedDesc('createdAt')) {
                                    <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                    }
                                </th>
                                <th scope="col">Who</th>
                                <th scope="col">What</th>
                                <th scope="col">Device</th>
                                <th scope="col">IP</th>
                                <th scope="col">Affected</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of entries; track entry.id) {
                            <tr class="clickable text-dark" (click)="view(entry)">
                                <td>{{entry.createdAt | date:'E MMM d, yyyy h:mm:ss a'}}</td>
                                <td>{{entry.user}} </td>
                                <td class="flex-start">
                                    <span class="pallette action-{{color(entry.action)}}">&nbsp;</span>
                                    <div>
                                        {{entry.action}}
                                        <p class="subtitle">{{entry.module}} {{entry.source}}</p>
                                    </div>
                                </td>
                                <td>
                                    {{entry.agent.ui || ''}} {{entry.agent.browser}} {{entry.agent.version}}
                                    <p class="subtitle">{{entry.agent.os}} {{entry.agent.device}}</p>
                                </td>
                                <td>{{entry.ip}}</td>
                                <td>
                                    @if (entry.sale) {
                                        {{entry.sale}}
                                        <p class="subtitle">{{entry.vehicle}} {{entry.contact || entry.lot}}</p>
                                    }
                                    @else if (entry.vehicle) {
                                        {{entry.vehicle}}
                                        @if (entry.lot) {
                                            <p class="subtitle">{{entry.lot}}</p>
                                        }
                                    }
                                    @else if (entry.contact) {
                                        {{entry.contact}}
                                    }
                                    @else {
                                        {{entry.lot || entry.corporation}}
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
            </div>
            <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                {{words[language]['displayed']}}</p>
        </div>
    </div>
}
</main>

<button class="d-none" data-target="#audit-log-meta-view" data-toggle="modal" id="btn-toggle-audit-meta-view"></button>
<div class="modal fade" id="audit-log-meta-view" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="auditLogMetaView">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Audit Entry</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                @if (metaIsArray) {
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Field</th>
                                <th scope="col">Was</th>
                                <th scope="col">Now</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (change of viewable.meta; track change) {
                                <tr>
                                    <td>{{change.field}}</td>
                                    <td>{{change.prev}}</td>
                                    <td>{{change.next}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
                @else {
                    <div class="detail"><pre>{{detail()}}</pre></div>
                }
            </div>
            <div class="modal-footer">
                @if (viewable) {
                    <p class="text-muted">{{viewable.createdAt | date:'E MMM d, yyyy h:mm:ss a'}}</p>
                }
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
